module.exports = __webpack_public_path__ + "static/media/sim2.fcccc513.svg";